import { CURRENT_FFS_API_VERSION } from '../core/constants';
import hashUser from '../util/hash';
export const CHANNEL_PREFIX = 'flagData';
export default class Broadcast {
  constructor(apiKey, user, stateUpdateCallback) {
    this.apiKey = apiKey;
    this.stateUpdateCallback = stateUpdateCallback;
    this.setupChannel(user);
  }
  updateUserContext(user) {
    this.stop();
    this.setupChannel(user);
  }
  sendFeatureFlagState(featureFlagState) {
    var _this$channel;
    (_this$channel = this.channel) === null || _this$channel === void 0 ? void 0 : _this$channel.postMessage(featureFlagState);
  }
  stop() {
    var _this$channel2;
    (_this$channel2 = this.channel) === null || _this$channel2 === void 0 ? void 0 : _this$channel2.close();
  }
  setupChannel(user) {
    try {
      // Keep reference to old channel so we can check the name of the current subscription
      // is the same as the channel we received a message for.
      // Due to a bug in Firefox which events can be recieved after
      // the channel has been closed.
      // eslint-disable-next-line compat/compat
      const channel = new BroadcastChannel(this.createChannelName(user));
      channel.onmessage = e => {
        var _this$channel3;
        if (channel.name === ((_this$channel3 = this.channel) === null || _this$channel3 === void 0 ? void 0 : _this$channel3.name)) {
          this.stateUpdateCallback(e.data);
        }
      };
      this.channel = channel;
    } catch (error) {
      // This could fail due to BroadcastChannel not available.
      // In that case, we do nothing.
    }
  }
  createChannelName(user) {
    return `${CHANNEL_PREFIX}.${CURRENT_FFS_API_VERSION}.${this.apiKey}.${hashUser(user)}`;
  }
}